import { useAtom } from "jotai";
import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
// import { changedLanguageAtom } from "../config/globalStates";

export default function Language() {
  // const { t, i18n } = useTranslation();

  // const [language, setLanguage] = useAtom(changedLanguageAtom);

  // const [selectedLanguage, setSelectedLanguage] = useState(language);

  const languages = [
    { code: "en", name: "English" },
    { code: "hi", name: "हिंदी" },
    { code: "mr", name: "मराठी" },
  ];

  // const handleLanguageChange = (code) => {
  //     setLanguage(code);
  //     setSelectedLanguage(code);
  //     i18n.changeLanguage(code);
  //     localStorage.setItem("selectedLanguage", code);
  // };

  return (
    <>
      <div className="min-[800px]:flex min-[800px]:gap-10 relative">
        <div className="mt-10 w-full min-[800px]:ml-40 p-4">
          <div className="flex justify-center mb-5 min-[800px]:justify-start">
            <h1 className="text-xl font-bold">Language</h1>
          </div>
          {languages.map((language, index) => (
            <>
              <div className="flex items-center justify-between mt-3">
                <h1 className="text-lg min-[800px]:mr-52">{language.name}</h1>
                <input
                  type="radio"
                  name="language"
                  // value={selectedLanguage}
                  // checked={selectedLanguage === language.code}
                  // onChange={() => handleLanguageChange(language.code)}
                  // onClick={() => i18n.changeLanguage(language.code)}
                  className="form-radio text-blue-600 h-4 w-4 ml-4"
                />
              </div>
              {index < languages.length - 1 && (
                <div className="border-t border-gray-300 mt-2"></div>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  );
}
